import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { companyInfo } from "../data/mockData";

const Footer = () => {
  return (
    <footer className="bg-[#1A1A2E] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src="/logo-white.png"
                alt="Key Vest Massilia"
                className="h-14 w-auto"
              />
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              {companyInfo.description}
            </p>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-[#C4956A]">
              Navigation
            </h4>
            <div className="space-y-3">
              <Link
                to="/"
                className="block text-sm text-white/60 hover:text-white transition-colors"
              >
                Accueil
              </Link>
              <Link
                to="/solution"
                className="block text-sm text-white/60 hover:text-white transition-colors"
              >
                Notre solution
              </Link>
              <Link
                to="/realisations"
                className="block text-sm text-white/60 hover:text-white transition-colors"
              >
                Réalisations
              </Link>
              <Link
                to="/ressources"
                className="block text-sm text-white/60 hover:text-white transition-colors"
              >
                Ressources
              </Link>
              <Link
                to="/contact"
                className="block text-sm text-white/60 hover:text-white transition-colors"
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-[#C4956A]">
              Nos services
            </h4>
            <div className="space-y-3">
              <p className="text-sm text-white/60">Diagnostic & Stratégie</p>
              <p className="text-sm text-white/60">Recherche & Sélection</p>
              <p className="text-sm text-white/60">Rénovation & Pilotage</p>
              <p className="text-sm text-white/60">Ameublement & Location</p>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-[#C4956A]">
              Contact
            </h4>
            <div className="space-y-3">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-3 text-sm text-white/60 hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                {companyInfo.phone}
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-3 text-sm text-white/60 hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4 flex-shrink-0" />
                {companyInfo.email}
              </a>
              <div className="flex items-start gap-3 text-sm text-white/60">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                {companyInfo.address}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">
            © {new Date().getFullYear()} Key Vest Massilia. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="text-xs text-white/40 hover:text-white/60 transition-colors"
            >
              Mentions légales
            </Link>
            <Link
              to="/"
              className="text-xs text-white/40 hover:text-white/60 transition-colors"
            >
              Politique de confidentialité
            </Link>
            <Link
              to="/"
              className="text-xs text-white/40 hover:text-white/60 transition-colors"
            >
              CGU
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
